"use client"

import { createContext, createElement, useContext, useEffect, useRef } from "react"
import type { ReactNode } from "react"

import { useScrollLock } from "@/lib/hooks/use-scroll-lock"

const OverlayPreviewContext = createContext(false)

export const OverlayPreviewProvider = ({ children }: { children: ReactNode }) => createElement(OverlayPreviewContext.Provider, { value: true }, children)

export const useOverlayPreview = () => useContext(OverlayPreviewContext)

export const useOverlayDismiss = (open: boolean, onClose?: () => void) => {
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose
  const isPreview = useOverlayPreview()
  useScrollLock(open && !isPreview)

  useEffect(() => {
    if (!open || isPreview) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onCloseRef.current?.()
    }
    document.addEventListener("keydown", onKeyDown)
    return () => document.removeEventListener("keydown", onKeyDown)
  }, [open, isPreview])
}
